import { render, staticRenderFns } from "./GDriveSelector.vue?vue&type=template&id=64ee544e&scoped=true&"
import script from "./GDriveSelector.vue?vue&type=script&lang=js&"
export * from "./GDriveSelector.vue?vue&type=script&lang=js&"
import style0 from "./GDriveSelector.vue?vue&type=style&index=0&id=64ee544e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ee544e",
  null
  
)

export default component.exports